import * as angular from "angular";

angular
  .module('bringoz.admin.agreements',
    [
      // 'ui.tinymce'
    ]);
